module.exports = __webpack_public_path__ + "img/73.5cff16c3.jpg";